module.exports = {
  // 界面
  refresh: 'Обновить',
  the_side_slip: 'Боковая панель',
  close_current_tab: 'Закрыть текущую вкладку',
  close_other_tab: 'Закрыть другие вкладки',
  close_all_tab: 'Закрыть все вкладки',

  // 类别
  add_next_level: 'Добавить следующий уровень',
  add_same_level: 'Добавить тот же уровень',
  parent_category: 'Родительская категория',

  // 通用
  new: 'Добавить',
  copy_new: 'Копировать и добавить',
  choose_new: 'Выбрать и добавить',
  edit: 'Редактировать',
  delete: 'Удалить',
  batch_delete: 'Удалить партию',
  ok: 'ОК',
  save: 'Сохранить',
  copy: 'Копировать',
  save_and_copy: 'Сохранить и копировать',
  confirm_and_copy: 'Подтвердить и копировать',
  cancel: 'Отмена',
  reset: 'Сбросить',
  refresh: 'Обновить',
  input_search_content: 'Введите запрос...',
  name: 'Имя',
  name2: 'ФИО',
  full_name: 'ФИО',
  full_name2: 'Полное имя',
  is_valid: 'Действительно',
  yes: 'Да',
  no: 'Нет',
  none: 'Нет',
  have: 'Есть',
  nothing: 'Ничего',
  infomation: 'Информация',
  remark: 'Примечание',
  description: 'Описание',
  serial_no: 'Серийный номер',
  close: 'Закрыть',
  audit: 'Аудит',
  unaudit: 'Отмена аудита',
  color: 'Цвет',
  color2: 'Краска',
  is_cash: 'Наличные',
  is_default: 'По умолчанию',
  print: 'Печать',
  reprint: 'Печать снова',
  import: 'Импорт',
  export: 'Экспорт',
  menu: 'Меню',
  quotation: 'Котировка',
  message: 'Сообщение',
  quote_item: 'Элемент котировки',
  preview: 'Предпросмотр',
  batch: 'Партия',
  plan_no: 'Номер плана',
  result: 'Результат',
  image: 'Изображение',
  content: 'Содержание',
  introduction: 'Введение',
  sort_order: 'Сортировка',
  choose_image: 'Выбрать изображение',
  no_nodes: 'без узлов',

  // 通用功能接口
  supplier_category: 'Категория поставщика',
  supplier: 'Поставщик',
  client: 'Клиент',
  payment_method: 'Метод оплаты',
  warehouse: 'Склад',
  code: 'Код',
  model: 'Модель',
  standard: 'Стандарт',
  unit: 'Единица',
  category: 'Категория',
  goods_category: 'Категория товара',
  goods_category2: 'Категория продукта',
  positions: 'Позиции',
  date: 'Дата',
  please_choose: 'Пожалуйста, выберите',
  invoice_no: 'Номер счета',
  po_no: 'Номер заказа',
  po_no2: 'PO No.',
  view: 'Просмотр',
  goods: 'Товары',
  goods2: 'Продукты',
  org_name: 'Название организации',
  org: 'Организация',
  total: 'Итого',
  retail_price: 'Розничная цена',
  retail_price2: 'Розничная цена 2',
  mini_retail_price: 'Мин. розничная цена',
  consignment_price: 'Цена консигнации',
  login: 'Войти',
  logout: 'Выйти',
  change_password: 'Изменить пароль',
  the_front: 'Фронт',
  the_back: 'Бэк',

  contacts: 'Контакты',
  contact_person: 'Контактное лицо',
  contacts_department: 'Отдел контактов',
  contacts_post: 'Должность контактов',
  post: 'Пост',
  mobile: 'Мобильный',
  office_phone: 'Офисный телефон',
  fax: 'Факс',
  email: 'Эл. почта',
  post_code: 'Почтовый индекс',
  zip_code: 'Почтовый код',
  address: 'Адрес',
  address2: 'Место проживания',
  website: 'Вебсайт',
  website2: 'Сайт',
  bank_account: 'Банковский счет',
  accounts_receivable: 'Дебиторская задолженность',
  accounts_payable: 'Кредиторская задолженность',

  workshop: 'Мастерская',
  phone: 'Телефон',
  principal: 'Руководитель',

  accountbook: 'Бухгалтерская книга',
  ticket_number: 'Номер билета',

  cost: 'Стоимость',
  total_cost: 'Общая стоимость',
  brand: 'Бренд',
  barcode: 'Штрих-код',
  barcode2: 'Штрих-код',
  qrcode: 'QR-код',
  imei: 'IMEI',

  search: 'Поиск',
  confirm: 'Подтвердить',
  discount: 'Скидка',
  sell_price: 'Цена продажи',
  seller: 'Продавец',
  member: 'Член',
  member_name: 'Имя члена',
  goods_search: 'Поиск товара',
  hold_receipt: 'Hold квитанция',
  unchecked: 'Не проверено',
  order: 'Заказ',
  order_report: 'Отчет по заказам',
  pay_money: 'Оплатить',
  paid_money: 'Оплачено',
  unpaid_money: 'Не оплачено',

  in_warehouse: 'В склад',
  out_warehouse: 'Из склада',

  sundry_category: 'Разная категория',
  money: 'Деньги',
  tax_amount: 'Сумма налога',
  tax_point: 'Налоговая ставка',
  tax_rate: 'Налоговая ставка',
  profit: 'Прибыль',
  profit_rate: 'Рентабельность',
  profit_rate2: 'Процент прибыли',

  user_group: 'Группа пользователей',
  is_see_money: 'Видеть деньги',
  is_see_cost: 'Видеть стоимость',
  is_stock_reminder: 'Напоминание о запасах',
  is_expired_reminder: 'Напоминание о сроке',

  is_front: 'Доступно фронту',
  remember_login_name: 'Запомнить имя входа',
  remember_password: 'Запомнить пароль',
  expiry_date: 'Дата окончания',
  cashier: 'Кассир',
  is_hold: 'Hold',
  is_order: 'Заказ',
  walk_in: 'Проходящий',
  amount_received: 'Полученная сумма',
  discount_money: 'Сумма скидки',
  payment: 'Платеж',
  settle: 'Оплатить',
  obsolete: 'Устаревший',
  exchange: 'Обмен',
  return: 'Возврат',
  return2: 'Назад',
  return_and_exchange: 'Возврат/Обмен',
  total_quantity: 'Общее количество',
  change: 'Сдача',
  total_amount: 'Общая сумма',
  pay_money: 'Полученная сумма',
  upload: 'Загрузить',
  fuzzy_query: 'Нечеткий запрос',
  shelf_lift: 'Срок хранения',
  maintenance_period: 'Период обслуживания',
  to_warehouse: 'В склад',
  from_warehouse: 'Из склада',
  stock_transfer_in: 'Перемещение на склад',
  summary_data: 'Сводные данные',
  detail_data: 'Детализированные данные',
  shop: 'Магазин',
  item: 'Элемент',
  source_quantity: 'Исходное количество',
  confirm_and_stay: 'Подтвердить и остаться',
  total_quantity: 'Общее количество',
  confirm_password: 'Подтвердить пароль',

  delivery_person: 'Доставщик',
  status: 'Статус',
  state: 'Состояние',
  stock_state: 'Состояние склада',
  order_date: 'Дата заказа',
  order_time: 'Время заказа',
  order_date2: 'Дата заказа',
  order_time2: 'Время заказа',
  order_date3: 'Дата заказа',
  delivery_date: 'Дата доставки',
  delivery_date2: 'Дата доставки',
  delivery_date3: 'Дата доставки',
  delivery_time: 'Время доставки',
  order_flag: 'Маркер заказа',
  client_family_name: 'Фамилия клиента',
  client_phone: 'Телефон клиента',
  other: 'Другое',
  extra_year: 'Дополнительный год гарантии',
  area: 'Район',
  area2: 'Район',
  update: 'Обновление',
  update_man: 'Обновление',
  start_time: 'Время начала',
  end_time: 'Время окончания',
  invoice_date: 'Дата выставления счета',
  invoice_date2: 'Дата выставления счета',
  drilling_wall: 'Пробуривание стены',
  handler: 'Обработчик',
  uses: 'Использование',

  total_salary: 'Общая зарплата',
  base_salary: 'Базовая зарплата',
  commission: 'Комиссия',
  special_bonus: 'Специальный бонус',
  bonus: 'Бонус',
  maintain_commission: 'Сохранить комиссию',
  maintain_expense: 'Сохранить расходы',
  maintain_bonus: 'Сохранить бонус',
  maintenance_bonus: 'Бонус за обслуживание',
  maintenance_expense: 'Расходы на обслуживание',
  maintenance_spare: 'Запасы на обслуживание',

  type: 'Тип',
  type2: 'Тип',
  sundry_expenditure: 'Различные расходы',
  salary_expenditure: 'Расходы на зарплату',
  fixed_expense: 'Фиксированные расходы',
  shop_expense: 'Расходы на магазин',
  extra_expense: 'Дополнительные расходы',
  netprofit: 'Чистая прибыль',
  export_excel: 'Экспорт в Excel',

  current_password: 'Текущий пароль',
  new_password: 'Новый пароль',
  print_invoice: 'Печать счета',
  job_title: 'Должность',
  supplier_name: 'Наименование поставщика',
  modify_time: 'Время изменения',
  for_delivery: 'Для доставки',
  processing: 'Обработка',
  total_sales_volume: 'Общий объем продаж',
  a_month_total_sales_volume: 'Общий объем продаж за месяц',
  difference_quantity: 'Разница в количестве',
  replenish_application: 'Заявка на пополнение',
  application_quantity: 'Количество в заявке',
  audit_quantity: 'Количество на проверке',
  replenish_quantity: 'Количество пополнения',
  replenish_amount: 'Сумма пополнения',
  estimated_date: 'Ожидаемая дата поставки',

  project: 'Проект',
  project2: 'Проект',
  project_category: 'Категория проекта',
  project_code: 'Код проекта',
  project_name: 'Название проекта',
  project_address: 'Адрес проекта',
  deduct: 'Вычет',
  bank: 'Банк',
  account_name: 'Наименование счета',
  account_no: 'Номер счета',

  maintenance_status: 'Статус обслуживания',
  notification_status: 'Статус уведомления',
  expected_finish_day: 'Ожидаемый день завершения',
  income_expenditure: 'Доходы/Расходы',
  amount_mop: 'Сумма/MOP',
  amount_hk: 'Сумма/HK',
  reimbursement_people: 'Ответственное лицо за возмещение',
  month_sell_quantity: 'Количество продаж за месяц',
  sales_volume: 'Объем продаж',
  version: 'Версия',

  //Table分页文字
  table_jump_to: 'Перейти на',
  table_page: 'страницу',
  table_go: 'Перейти',
  table_total: 'Всего',
  table_item: 'элементов',
  table_limit_each_page: 'элементов на странице',

  password: 'Пароль',
  verify_password: 'Подтвердить пароль',
  login_name: 'Имя пользователя',
  nickname: 'Псевдоним',

  summary: 'Сводка',
  bank_name: 'Наименование банка',
  balance: 'Баланс',
  balance_mop: 'Баланс/MOP',
  balance_hk: 'Баланс/HK',
  account_holder: 'Владелец счета',
  last_period_balance: 'Баланс за предыдущий период',
  last_period_balance2: 'Баланс за предыдущий период',

  //Table Title文字
  id: 'ID',
  amount: 'Сумма',
  price: 'Цена',
  quantity: 'Количество',
  goods_code: 'Код товара',
  goods_name: 'Наименование товара',
  goods_code2: 'Код товара',
  goods_name2: 'Наименование товара',
  is_audit: 'Проверено',
  electroplate: 'Электрофорез',
  is_electroplate: 'Электрофорез',
  polishing: 'Полировка',
  is_polishing: 'Полировка',

  receivable: 'Сумма к получению',
  payable: 'Сумма к оплате',
  deposit: 'Задаток',
  title: 'Название',
  special_price: 'Специальная цена',

  // 仓库
  leader: 'Руководитель',
  tel: 'Телефон',
  location: 'Местоположение',

  //维修单
  acceptance_date: 'Дата приема',
  client_name: 'Имя клиента',
  acceptance_model: 'Модель приема',
  serial_number: 'Серийный номер',
  serial_number2: 'Номер',
  serial_number3: 'Номер',
  graphic_lock: 'Графический замок',
  maintain_history: 'История обслуживания',
  warranty_status: 'Статус гарантии',
  follow_parts: 'Дополнительные компоненты',
  fault_cause: 'Причина неисправности',
  fault_phenomenon: 'Симптом неисправности',
  need_parts: 'Необходимые компоненты',
  maintain_evaluate: 'Оценка обслуживания',
  advance_payment: 'Авансовый платеж',
  spare_phone: 'Запасной телефон',
  spare_model: 'Запасная модель',
  retrieve_date: 'Дата получения',
  acceptance_status: 'Статус приема',

  choose_delivery_note: 'Выбрать доставочную ноту',
  export_pdf: 'Экспортировать в PDF',
  export_list: 'Экспортировать список',
  export_monthly_analyze: 'Экспорт месячного анализа',
  reinforcemoney: 'Денежное подкрепление',
  reminder_date: 'Дата напоминания',
  total_money: 'Общая сумма',
  incomepay_type: 'Тип дохода/расхода',
  difference_cost: 'Разница в стоимости',
  sell_date: 'Дата продажи',
  setting_sales_volume: 'Установка объема продаж',
  negative_difference_quantity: 'Отрицательная разница в количестве',
  exchange_rate: 'Курс обмена',

  product_category: 'Категория продукта',
  product: 'Продукт',
  problem_type: 'Тип проблемы',
  item_count: 'Количество элементов',
  function: 'Функция',
  handling_type: 'Тип обработки',
  handling_description: 'Описание обработки',

  audited: 'Проверено',
  unaudited: 'Не проверено',
  all: 'Все',
  credit: 'Кредит',
  repayment: 'Погашение',
  credit_amount: 'Сумма кредита',
  repayment_amount: 'Сумма погашения',
  pay_type: 'Тип платежа',
  paid: 'Оплачено',
  unpaid: 'Неоплачено',
  make_journal: 'Создать журнал',
  cash_journal: 'Журнал наличных',
  bank_journal: 'Банковский журнал',
  invoice_journal: 'Журнал счетов',
  receive_reminder: 'Получить напоминание',
  income: 'Доход',
  expenditure: 'Расход',
  last_in_cost: 'Последняя стоимость поступления',
  stock_cost: 'Стоимость запаса',
  cash_balance_mop: 'Баланс наличных MOP',
  cash_balance_hk: 'Баланс наличных HK',
  bank_balance_mop: 'Баланс банка MOP',
  bank_balance_hk: 'Баланс банка HK',
  invoice_balance_mop: 'Баланс счетов MOP',
  invoice_balance_hk: 'Баланс счетов HK',
  check_no: 'Номер чека',
  is_get: 'Получено ли',
  is_get2: 'Получено',
  not_get: 'Не получено',
  payment_entry: 'Запись платежа',
  payment_type: 'Тип платежа',
  show_index: 'Показать индекс',
  quote_remark: 'Примечание к цитате',

  greater_than_zero: 'Больше 0',
  equal_to_zero: 'Равно 0',
  less_than_zero: 'Меньше 0',
  greater_than_zero2: '>0',
  equal_to_zero2: '=0',
  less_than_zero2: '<0',

  previous_day: 'Предыдущий день',
  purchase_in: 'Закупка на склад',
  purchase_return: 'Возврат закупки',
  stock_transfer_out: 'Перемещение со склада',
  consignment_out: 'Отправка на консигнацию',
  consignment_in: 'Возврат консигнации',
  retail: 'Розничная торговля',
  retail_return: 'Розничная торговля - возврат',
  stock_adjust: 'Корректировка склада',
  current_day: 'Текущая дата',
  add_deposit: 'Добавить депозит',
  order_quantity: 'Количество заказа',
  order_quantity2: 'Количество по заказу',
  arrival_date: 'Дата прибытия',
  picture: 'Изображение',
  goods_detail: 'Детали товара',
  goods_detail2: 'Детали продукта',
  spec_parameter: 'Спецификация/параметр',
  extend_price: 'Расширенная цена',
  open_time: 'Время открытия',
  booking: 'Бронирование',
  new_product: 'Новый продукт',
  spot_sale: 'Продажа со склада',
  is_corporate_account: 'Корпоративный аккаунт',
  corporate_account: 'Корпоративный аккаунт',
  keep_accounts: 'Вести учет',
  sort: 'Сортировка',
  miniprogram: 'Минипрограмма',
  miniprogram_price: 'Цена минипрограммы',
  delivery_way: 'Способ доставки',
  service: 'Услуга',
  value_added_services: 'Дополнительные услуги',
  extended_warranty: 'Продленная гарантия',
  size: 'Размер',
  month: 'Месяц',
  month2: 'Месяц',
  send: 'Отправить',
  detail_address: 'Подробный адрес',
  delivery_place: 'Место доставки',
  contracted_address: 'Сокращенный адрес',
  job_content: 'Содержание работы',
  foreign_name: 'Иностранное имя',
  spec: 'Спецификация',
  spec2: 'Спецификация и модель',
  product_code: 'Код продукта',
  product_name: 'Наименование продукта',
  product_spec: 'Спецификация продукта',
  product_spec2: 'Модель продукта',
  stuff_code: 'Код материала',
  stuff_name: 'Наименование материала',
  stuff_spec: 'Спецификация материала',
  stuff_spec2: 'Спецификация и модель материала',
  material_code: 'Код материала',
  material_name: 'Наименование материала',
  material_spec: 'Спецификация материала',
  material_spec2: 'Спецификация и модель материала',
  goods_spec: 'Спецификация товара',
  goods_spec2: 'Спецификация и модель товара',
  system_item_can_not_edit: 'Системный элемент, нельзя редактировать',
  system_item_can_not_delete: 'Системный элемент, нельзя удалить',
  uses: 'Использование',
  supply_code: 'Код поставки',
  is_occupy_can_not_unaudit: 'Уже занят, нельзя отменить аудит',
  receive_payment_date: 'Дата получения платежа',
  payment_date: 'Дата платежа',
  delivery_no: 'Номер доставки',
  reconcile_date: 'Дата сверки',
  receipt_date: 'Дата квитанции',
  receipt_start_date: 'Дата начала квитанции',
  receipt_end_date: 'Дата окончания квитанции',
  short_name: 'Краткое название',
  client_short_name: 'Краткое название клиента',
  supply_type: 'Тип поставки',
  sell_type: 'Тип продажи',
  stuff: 'Материал',
  material: 'Материал',
  semi_finished_product: 'Полуфабрикат',
  client_order_no: 'Номер заказа клиента',
  maker: 'Создатель',
  auditor: 'Аудитор',
  auditor2: 'Аудитор',
  time_unit_price: 'Цена за единицу времени',
  delivery_quantity: 'Количество доставки',
  owe_quantity: 'Недостающее количество',
  order_amount: 'Сумма заказа',
  total_man_hour: 'Общее количество часов',
  production_date: 'Дата производства',
  person_number: 'Количество человек',
  person_man_hour: 'Часов на человека',
  man_hour: 'Часов',
  material_price: 'Цена материала',
  check_stock: 'Проверить склад',
  packages: 'Количество пакетов',
  is_xcx: 'Минипрограмма',
  is_web: 'Веб-сайт',
  stock: 'Запас',
  handling_method: 'Метод обработки',
  problem: 'Проблема',
  guarantee_clause: 'Гарантийные условия',
  privacy_policy: 'Политика конфиденциальности',
  user_agreement: 'Пользовательское соглашение',
  user_guide: 'Руководство пользователя',
  contact_us: 'Свяжитесь с нами',

  create_date: 'Дата создания',
  create_by: 'Оформил',
  create_by2: 'Создатель',
  application_date: 'Дата заявки',
  modify_date: 'Дата изменения',
  clear: 'Очистить',

  edit_mode: 'Режим редактирования',
  close_other: 'Закрыть другие',
  close_all: 'Закрыть все',
  close_this: 'Закрыть текущее',

  start_date: 'Дата начала',
  end_date: 'Дата окончания',
  select_week: 'Выбрать неделю',
  query_condition: 'Условие запроса',

  stock_limit: 'Ограничение запаса',
  stock_lower: 'Нижний предел запаса',
  mini_stock: 'Минимальный запас',
  max_stock: 'Максимальный запас',
  add_material: 'Добавить материал',
  add_material_money: 'Сумма за материал',
  turnover: 'Оборот',
  sales_ranking: 'Рейтинг продаж',
  total_sales_ranking: 'Общий рейтинг продаж',
  stock_location: 'Местоположение на складе',
  yesterday: 'Вчера',
  today: 'Сегодня',
  this_month: 'Этот месяц',
  a_month: 'Месяц',
  last_month: 'Прошлый месяц',
  this_year: 'Этот год',
  last_year: 'Прошлый год',
  setmeal: 'Комплект',
  process: 'Процесс',
  length: 'Длина',
  height: 'Высота',
  height2: 'Высота',
  chipset: 'Чип',
  chipset2: 'Механизм',
  hour_minute_hand: 'Часовая и минутная стрелки',
  second_hand: 'Секундная стрелка',
  finished: 'Завершено',
  unfinished: 'Не завершено',
  sell_out_quantity: 'Количество проданного',
  sell_out_quantity2: 'Количество отправленного',
  wechat: 'WeChat',
  consignment_category: 'Категория консигнации',
  order_no: 'Номер заказа',
  stock_quantity: 'Количество на складе',
  is_used: 'Использовано',
  used: 'Использовано',
  unused: 'Не использовано',
  subtotal: 'Промежуточный итог',
  sell_out_date: 'Дата отправки',
  sheets: 'Листы',
  pieces: 'Штуки',
  backup: 'Резервное копирование',
  spare: 'Резерв',
  floor: 'Этаж',
  category_type: 'Тип категории',

  grade: 'Уровень',
  auto_coding: 'Автокодирование',
  manual_coding: 'Ручное кодирование',
  hour: 'Час',
  minute: 'Минута',
  second: 'Секунда',
  negotiation_date: 'Дата переговоров',
  negotiator: 'Переговорщик',
  next_date: 'Дата следующей встречи',
  next_content: 'Содержание следующей встречи',
  is_connected: 'Связано',
  final_date: 'Дата завершения',
  task_executor: 'Исполнитель задачи',
  take_time: 'Затраченное время',
  task_content: 'Содержание задачи',
  tester: 'Тестировщик',
  task_finish_type: 'Тип завершения задачи',
  finish_flag: 'Флаг завершения',
  issue_category: 'Категория проблемы',
  issue_collection: 'Сбор проблем',
  issue_content: 'Содержание проблемы',
  project_status: 'Статус проекта',
  create_task: 'Создать задачу',
  service_name: 'Название услуги',
  service_item: 'Элемент услуги',
  service_details: 'Детали услуги',
  service_fee: 'Плата за услуги',
  active_status: 'Статус активности',
  staff_code: 'Код сотрудника',
  staff_name: 'Имя сотрудника',
  task_type: 'Тип задачи',
  default_price: 'Цена по умолчанию',
  default_purchase_price: 'Закупочная цена по умолчанию',
  default_sell_price: 'Цена продажи по умолчанию',
  material_category: 'Категория материалов',
  product_category: 'Категория продуктов',
  addressee: 'Получатель',
  receipt_date: 'Дата получения',
  delivery_person: 'Доставщик',
  remaining_quantity: 'Оставшееся количество',
  finish_quantity: 'Завершенное количество',
  inventory_quantity: 'Количество на складе',
  stock_in_type: 'Тип прихода на склад',
  stock_out_type: 'Тип расхода со склада',
  molds: 'Формы',
  molds2: 'Шаблоны',
  card_slot: 'Слот карты',
  formula: 'Формула',
  formula2: 'Рецепт',
  modifier: 'Изменивший',
  diffuser: 'Диффузор',
  sell_order: 'Заказ на продажу',
  unit_quantity: 'Количество единиц',
  production_order: 'Производственный заказ',
  sex: 'Пол',
  birthday: 'День рождения',
  id_card: 'Идентификационная карта',
  department: 'Отдел',
  hiredate: 'Дата приема на работу',
  salesman: 'Продавец',
  calc_attendance: 'Рассчитать посещаемость',
  attendance: 'Посещаемость',
  production_no: 'Номер производственного заказа',
  category_code: 'Код категории',
  client_product_code: 'Код продукта клиента',
  buyer: 'Покупатель',
  client_order: 'Заказ клиента',
  sell_billing: 'Выставление счета на продажу',
  client_return: 'Возврат клиента',
  sell_summary: 'Сводка продаж',
  yield_rate: 'Коэффициент выхода годных',
  stock_alert: 'Предупреждение о запасах',
  inspection_type: 'Тип проверки',
  product_description: 'Описание продукта',
  inspection_quantity: 'Количество проверок',
  inspector: 'Инспектор',
  inspector2: 'Контролер',
  inspection_result: 'Результат проверки',
  inspection_remark: 'Примечание к проверке',
  overdue: 'Просрочено',
  audit_time: 'Время проверки',
  customer_complaint: 'Жалоба клиента',
  process_result: 'Результат обработки',
  defect_rate: 'Уровень дефектов',
  improvement_plan: 'План улучшения',
  wilfulness: 'Ответственный',
  month_of_payment: 'Месяц оплаты',
  invoice_money: 'Сумма счета',
  invoice_money2: 'Сумма по счету',
  recorder: 'Регистратор',
  analyst: 'Аналитик',


  // 餐飲管理系統
  production_location: 'Место производства',
  food_category: 'Категория продуктов',
  option: 'Опция',
  option_money: 'Стоимость опции',
  picture: 'Картинка',
  food_material: 'Ингредиенты',
  food_material_category: 'Категория ингредиентов',
  table_number: 'Номер стола',
  member_category: 'Категория членов',
  recharge: 'Пополнение',
  give_away: 'Подарок',
  card_number: 'Номер карты',
  food_name: 'Название блюда',
  food: 'Еда',
  shelf_life: 'Срок годности',
  main_currency: 'Основная валюта',
  number_of_people: 'Количество людей',
  extra_order: 'Дополнительный заказ',
  settlement: 'Расчет',
  share_table: 'Общий стол',
  change_table: 'Смена стола',


  // 提示
  confirm_save: 'Подтвердить сохранение',
  confirm_cancel: 'Подтвердить отмену',
  confirm_delete: 'Подтвердить удаление',
  confirm_audit: 'Подтвердить аудит',
  confirm_unaudit: 'Подтвердить отмену аудита',
  confirm_obsolete: 'Подтвердить устаревание',
  confirm_transfer_in: 'Подтвердить перевод',
  confirm_print: 'Подтвердить печать',

  please_choose_detail: 'Пожалуйста, выберите детали',
  please_choose_data: 'Пожалуйста, выберите данные',
  please_choose_payment_method: 'Пожалуйста, выберите способ оплаты',
  please_choose_client: 'Пожалуйста, выберите клиента',
  please_choose_audited_data: 'Пожалуйста, выберите проверенные данные',
  please_enter_login_name: 'Пожалуйста, введите имя пользователя',
  please_enter_password: 'Пожалуйста, введите пароль',
  please_enter_org: 'Пожалуйста, введите организацию',
  org_error: 'Ошибка организации',

  save_success: 'Успешно сохранено',
  save_failed: 'Не удалось сохранить',
  save_data_success: 'Данные успешно сохранены',
  save_data_failed: 'Ошибка сохранения данных',
  delete_data_success: 'Данные успешно удалены',
  delete_data_failed: 'Ошибка удаления данных',
  audit_data_success: 'Данные успешно проверены',
  audit_data_failed: 'Ошибка проверки данных',
  unaudit_data_success: 'Отмена проверки данных успешна',
  unaudit_data_failed: 'Ошибка отмены проверки данных',
  move_failed: 'Ошибка перемещения',

  success: 'Успешно',
  failed: 'Не удалось',
  error: 'Ошибка',
  unknown_error: 'Неизвестная ошибка',
  will_delete_all: 'Удалит все дочерние данные',
  data_does_not_exist: 'Данные не существуют',
  no_data: 'Нет данных',
  prev_page: 'Предыдущая страница',
  next_page: 'Следующая страница',
  low_stocks: 'Недостаточный запас',
  insufficient_payment: 'Недостаточная сумма оплаты',
  login_name_or_password_wrong: 'Неправильное имя пользователя или пароль',
  login_success: 'Успешный вход',
  no_permission: 'Нет разрешения',
  password_not_match: 'Пароль не совпадает',
  password_changed_successfully: 'Пароль успешно изменен',
  verify_password_not_match: 'Подтверждение пароля не совпадает',
  can_not_have_special_characters: 'Не может содержать специальные символы',
  can_not_empty: 'Не может быть пустым',
  password_must_be_less_than_12_digits_and_no_spaces: 'Пароль должен содержать менее 12 символов и не содержать пробелов',
  do_not_underline_at_the_beginning_and_end: 'Не должно быть подчеркиваний в начале и конце',
  this_value_already_exists: 'Это значение уже существует',
  must_be_unique: "Должно быть уникальным",
  if_hold: 'Удерживать документ?',
  data_not_found: 'Данные не найдены',
  data_not_audited: 'Данные не проверены',
  lower_than_minimum_retail_price: 'Не может быть ниже минимальной розничной цены',
  invoice: 'Счет',
  proofreading_invoice: 'Сверка счета',
  receipt: 'Квитанция',
  order_invoice: 'Счет на предзаказ',
  receipt_type: 'Тип документа',
  change_client_will_del_all_continue: 'Смена клиента удалит все детальные данные и их невозможно будет восстановить. Продолжить?',
  current_password_not_match: 'Текущий пароль не совпадает',
  print_done: 'Печать завершена',
  unselected_data: 'Не выбраны данные',
  process_success: 'Обработка успешна',
  process_failed: 'Ошибка обработки',
  process_failed_please_try_agin: 'Ошибка обработки, попробуйте еще раз',
  process_timeout_please_try_agin: 'Превышено время ожидания, попробуйте еще раз',
  process_error: 'Ошибка обработки',
  copy_done: 'Копирование успешно',
  pay_amount_more_than_total_amount: 'Сумма оплаты больше общей суммы',
  data_sent_successfully: 'Данные успешно отправлены',
  invalid_email_format: 'Неверный формат E-mail',
  invalid_phone_format: 'Неверный формат телефона',
  login_has_expired: 'Срок действия входа истек, пожалуйста, войдите снова',
  please_input_number_of_people: 'Пожалуйста, введите количество людей',
  please_input_quantity: 'Пожалуйста, введите количество',
  please_input_member_mobile: 'Пожалуйста, введите номер мобильного телефона члена',
  please_input_money: 'Пожалуйста, введите сумму',
  please_input_discount: 'Пожалуйста, введите скидку',
  maximum_level_exceeded: 'Превышен максимальный уровень',
  no_member_found: 'Член не найден',
  please_choose_new_table: 'Пожалуйста, выберите новый стол',
  print_service_not_enabled: 'Служба печати не включена',
  detail_data_can_not_empty: 'Детальные данные не могут быть пустыми',
  used_data_cannot_be_deleted: 'Использованные данные не могут быть удалены',


  // 菜单
  menu_base_data: 'Основные данные',
  menu_goods_category: 'Категория товаров',
  menu_goods_standard: 'Спецификация товаров',
  menu_goods: 'Информация о товарах',
  menu_goods_category2: 'Категория продукции',
  menu_goods_standard2: 'Спецификация продукции',
  menu_goods2: 'Информация о продукции',
  menu_unit: 'Единица измерения',
  menu_color: 'Цвет',
  menu_payment_method: 'Способ расчета',
  menu_payment_method2: 'Способ оплаты',
  menu_brand: 'Бренд',
  menu_depart: 'Отдел',

  menu_member_manage: 'Управление членами',
  menu_member_category: 'Категория членов',
  menu_member: 'Информация о членах',
  menu_points_setting: 'Настройка баллов',
  menu_points_redeem: 'Обмен баллов',

  menu_purchase_manage: 'Управление закупками',
  menu_supplier_category: 'Категория поставщиков',
  menu_supplier: 'Информация о поставщиках',
  menu_purchase_plan: 'План закупок',
  menu_purchase_order: 'Заказ на закупку',
  menu_purchase_apply: 'Заявка на закупку',
  menu_purchase_in: 'Поступление закупок',
  menu_purchase_return: 'Возврат закупок',
  menu_purchase_auxiliary: 'Вспомогательная таблица закупок',
  menu_purchase_inquiry: 'Запрос цен',
  menu_supplier_quotes: 'Котировки поставщиков',

  menu_outsource_manage: 'Управление аутсорсингом',
  menu_outsource_out: 'Передача на обработку',
  menu_outsource_in: 'Возврат с обработки',
  menu_outsource_report: 'Отчет по аутсорсингу',
  menu_outsource_manage2: 'Управление внешней обработкой',
  menu_outsource_out2: 'Отправка на внешнюю обработку',
  menu_outsource_in2: 'Поступление с внешней обработки',
  menu_oem_in: 'Поступление на контрактное производство',
  menu_oem_out: 'Отправка на контрактное производство',

  menu_consignment_manage: 'Управление консигнацией',
  menu_consignment_out: 'Отправка на консигнацию',
  menu_consignment_out_detail: 'Детали отправки на консигнацию',
  menu_consignment_in: 'Возврат консигнации',
  menu_consignment_in_detail: 'Детали возврата консигнации',
  menu_consignment_proceeds: 'Поступление от консигнации',
  menu_consignment_proceeds_detail: 'Детали поступлений от консигнации',
  menu_consignment_uncollected: 'Неполученные поступления от консигнации',
  menu_consignment_proceeds_report: 'Отчет по поступлениям от консигнации',

  menu_stock_transfer_out: 'Перемещение из склада',
  menu_stock_transfer_in: 'Перемещение в склад',

  menu_warehouse_manage: 'Управление складом',
  menu_warehouse: 'Информация о складе',
  menu_stock_search: 'Поиск запасов',
  menu_stock_check: 'Инвентаризация',
  menu_stock_adjust: 'Корректировка запасов',
  menu_waste_in: 'Поступление брака',
  menu_waste_out: 'Вывод брака',
  menu_smart_replenishment: 'Умное пополнение',
  menu_goods_assemble: 'Сборка товаров',
  menu_goods_split: 'Разделение товаров',
  menu_other_stock_in: 'Прочее поступление',
  menu_other_stock_out: 'Прочий вывод',
  menu_stock_in_type: 'Тип поступления',
  menu_stock_out_type: 'Тип вывода',

  menu_production_manage: 'Управление производством',
  menu_workshop: 'Настройки цеха',
  menu_bom_setting: 'Настройки BOM',
  menu_production_plan: 'План производства',
  menu_production_list: 'Список производства',
  menu_production_order: 'Производственный заказ',
  menu_production_picking: 'Отбор материалов для производства',
  menu_production_return: 'Возврат материалов из производства',
  menu_product_in: 'Поступление продукции',
  menu_product_in_detail: 'Детали поступления продукции',
  menu_transfer_auxiliary: 'Вспомогательная таблица перевода',

  menu_sell_manage: 'Управление продажами',
  menu_wholesale_manage: 'Управление оптовыми продажами',
  menu_client_category: 'Категория клиентов',
  menu_client: 'Информация о клиентах',
  menu_customer: 'Информация о клиентах',
  menu_customer2: 'Информация о клиентах',
  menu_client_contact: 'Контактное лицо клиента',
  menu_sell_order: 'Заказ на продажу',
  menu_client_quote: 'Котировка клиента',
  menu_sell_out: 'Вывод товаров на продажу',
  menu_sell_out_detail: 'Детали вывода товаров на продажу',
  menu_sell_return: 'Возврат продаж',
  menu_client_order: 'Заказ клиента',
  menu_sell_billing: 'Выставление счета на продажу',
  menu_client_return: 'Возврат от клиента',
  menu_sell_summary: 'Сводка по продажам',

  menu_sundry_manage: 'Управление разным',
  menu_sundry_category: 'Категория разного',
  menu_sundry_entry: 'Ввод разного',
  menu_shop_sundry: 'Магазинные расходы',
  menu_fixed_expense: 'Фиксированные расходы',
  menu_shop_expense: 'Расходы магазина',
  menu_extra_expense: 'Дополнительные расходы',
  menu_salary_expenditure: 'Расходы на зарплату',
  menu_expenditure_report: 'Отчет по расходам',

  menu_finance_manage: 'Управление финансами',
  menu_accountbook: 'Настройка бухгалтерской книги',
  menu_receipt_entry: 'Ввод поступлений',
  menu_payment_entry: 'Ввод выплат',
  menu_receivable: 'Дебиторская задолженность',
  menu_payable: 'Кредиторская задолженность',
  menu_receipt_voucher: 'Квитанция о получении',
  menu_payment_voucher: 'Квитанция об оплате',
  menu_receivable_offset: 'Списание дебиторской задолженности',
  menu_payable_offset: 'Списание кредиторской задолженности',
  menu_other_receipt: 'Другие поступления',
  menu_other_payment: 'Другие выплаты',
  menu_expenses_type: 'Типы расходов',
  menu_expenses_entry: 'Ввод расходов',
  menu_supplier_account_balance: 'Баланс счета поставщика',
  menu_client_account_balance: 'Баланс счета клиента',

  menu_settlement_manage: 'Управление расчетами',

  menu_addressee: 'Получатель',
  menu_delivery_manage: 'Управление доставкой',
  menu_delivery_person: 'Курьер',
  menu_delivery_time: 'Время доставки',
  menu_non_delivery_date: 'Дата недоставки',
  menu_status: 'Статус',
  menu_delivery_note: 'Накладная на доставку',
  menu_delivery_billing: 'Выставление счета на доставку',
  menu_delivery_billing_report: 'Отчет по выставлению счетов на доставку',

  menu_maintain_manage: 'Управление ремонтом',
  menu_acceptance_status: 'Статус принятия',
  menu_maintenance_status: 'Статус ремонта',
  menu_notification_status: 'Статус уведомления',
  menu_maintain_note: 'Ремонтная накладная',
  menu_reservation_maintain_note: 'Резервная ремонтная накладная',
  menu_maintain_note_report: 'Отчет по ремонтным накладным',
  menu_reservation_maintain_note_report: 'Отчет по резервным ремонтным накладным',

  menu_system_setting: 'Настройки системы',
  menu_operation_log: 'Журнал операций',
  menu_system_param: 'Системные параметры',
  menu_user_group: 'Группа пользователей',
  menu_user: 'Информация о пользователе',
  menu_change_password: 'Изменение пароля',

  menu_report: 'Отчеты',
  menu_goods_tracking: 'Отслеживание товаров',
  menu_purchase_in_report: 'Отчет о закупках',
  menu_purchase_in_count: 'Статистика закупок',
  menu_stock_transfer_out_report: 'Отчет о перемещении со склада',
  menu_stock_count: 'Статистика запасов',
  menu_retail_profit: 'Розничная прибыль',
  menu_netprofit_report: 'Отчет о чистой прибыли',
  menu_daily_settlement: 'Ежедневные расчеты',
  menu_payment_method_daily: 'Ежедневные расчеты по способу оплаты',
  menu_daily_settlement_variance: 'Разница в ежедневных расчетах',
  menu_retail_settlement: 'Розничные расчеты',
  menu_retail_detail_report: 'Детальный отчет по рознице',
  menu_order_report: 'Отчет по заказам',
  menu_order_detail: 'Детали заказа',
  menu_order_statistics: 'Статистика заказов',
  menu_obsolete_report: 'Отчет об аннулировании',
  menu_return_report: 'Отчет о возвратах',
  menu_loss_report: 'Отчет о потерях',
  menu_profit_report: 'Отчет о прибыли',
  menu_net_profit_report: 'Отчет о чистой прибыли',
  menu_purchase_detail: 'Детали закупок',
  menu_sell_detail: 'Детали продаж',
  menu_inventory_warning: 'Предупреждение о запасах',
  menu_purchase_report: 'Отчет о закупках',
  menu_replenish_manage: 'Управление пополнением запасов',
  menu_replenish_application: 'Заявка на пополнение запасов',

  menu_supplier_quote: 'Котировки поставщика',
  menu_purchase_receipt: 'Закупочная квитанция',
  menu_object_manage: 'Управление проектами',
  menu_quote_recipt_status: 'Статус котировки',
  menu_project_setting: 'Настройки проекта',
  menu_project_category: 'Категория проекта',
  menu_project_category2: 'Категория проекта',
  menu_negotiation_category: 'Категория переговоров',
  menu_project_negotiation: 'Переговоры по проекту',
  menu_project_info: 'Информация о проекте',
  menu_project_quote: 'Котировка проекта',
  menu_project_quote2: 'Котировка проекта',
  menu_project_invoice: 'Счет-фактура проекта',
  menu_design_company_setting: 'Настройка проектной компании',
  menu_design_quote: 'Котировка дизайна',

  menu_income_expenditure_manage: 'Управление доходами и расходами',
  menu_income_type: 'Тип дохода',
  menu_expenditure_type: 'Тип расхода',

  menu_currency: 'Валюта',
  menu_bank_setting: 'Настройка банка',
  menu_bank_journal_type: 'Тип банковского журнала',
  menu_cash_journal_entry: 'Запись в кассовый журнал',
  menu_bank_journal_entry: 'Запись в банковский журнал',
  menu_invoice_journal_entry: 'Запись в журнал счетов-фактур',
  menu_check_journal_entry: 'Запись в журнал чеков',
  menu_debit_credit_entry: 'Запись дебета и кредита',
  menu_debit_entry: 'Запись дебета',
  menu_credit_entry: 'Запись кредита',
  menu_reimbursement_people: 'Возмещающий',
  menu_reimburse_entry: 'Запись о возмещении',

  menu_project_quote_report: 'Отчет по котировке проекта',
  menu_design_quote_report: 'Отчет по котировке дизайна',
  menu_receipt_report: 'Отчет по поступлениям',
  menu_payment_report: 'Отчет по платежам',
  menu_receipt_payment_detail: 'Детали доходов и расходов',
  menu_project_receipt_payment_detail: 'Детали доходов и расходов проекта',
  menu_profit_report: 'Отчет о прибыли',
  menu_cash_journal_report: 'Отчет по кассовому журналу',
  menu_bank_journal_report: 'Отчет по банковскому журналу',
  menu_invoice_journal_report: 'Отчет по журналу счетов-фактур',
  menu_check_journal_report: 'Отчет по журналу чеков',
  menu_debit_credit_report: 'Отчет по дебету и кредиту',
  menu_reimburse_report: 'Отчет о возмещении',

  menu_project_follow_up: 'Отслеживание проекта',
  menu_project_manage: 'Управление проектами',
  menu_after_sale_manage: 'Управление послепродажным обслуживанием',
  menu_after_sale: 'Послепродажное обслуживание',
  menu_customer_complaint: 'Жалобы клиентов',
  menu_problem_collection: 'Сбор проблем',
  menu_problem_handling: 'Решение проблем',
  menu_client_manage: 'Управление клиентами',
  menu_customer_manage: 'Управление клиентами',
  menu_receipt_type: 'Тип платежа',
  menu_material_category: 'Категория материалов',
  menu_product_category: 'Категория продуктов',
  menu_product_info: 'Информация о продукте',
  menu_area: 'Район',
  menu_problem_type: 'Тип проблемы',
  menu_handling_type: 'Тип обработки',
  menu_unfinished_problem: 'Незавершенные проблемы',
  menu_repayment_entry: 'Запись погашения',
  menu_credit_repayment_entry: 'Запись погашения кредита',
  menu_credit_report: 'Отчет по кредитам',
  menu_purchase_check_report: 'Отчет по проверке закупок',
  menu_monthly_balance: 'Ежемесячный баланс',
  menu_daily_balance_report: 'Ежедневный отчет о балансе',
  menu_daily_balance_detail: 'Детали ежедневного баланса',
  menu_edition_fee: 'Плата за издание',
  menu_edition_fee_return: 'Возврат платы за издание',
  menu_staff_info: 'Информация о сотрудниках',
  menu_settlement: 'Расчет',
  menu_supplier_statement: 'Выписка по счету поставщика',
  menu_client_statement: 'Выписка по счету клиента',
  menu_attendance_manage: 'Управление посещаемостью',
  menu_schedules_setting: 'Настройка графиков',
  menu_holiday_entry: 'Запись праздников',
  menu_absence_type: 'Тип отсутствия',
  menu_absence_entry: 'Запись отсутствия',
  menu_special_record: 'Специальная запись',
  menu_attendance_entry: 'Запись посещаемости',
  menu_attendance_statistics: 'Статистика посещаемости',
  menu_attendance_type: 'Тип посещаемости',

  menu_salary_manage: 'Управление зарплатой',
  menu_process_setting: 'Настройка процесса',
  menu_process: 'Процесс',
  menu_piecework_data_entry: 'Запись данных по сдельной работе',
  menu_piecework_report: 'Отчет по сдельной работе',
  menu_salary_statistics: 'Статистика зарплат',
  menu_salary_report: 'Отчет по зарплатам',
  menu_piecework_order: 'Сдельный заказ',
  menu_piecework_entry: 'Запись сдельной работы',
  menu_wage_entry: 'Запись зарплаты',

  menu_purchase_detail: 'Детали закупок',
  menu_sell_detail: 'Детали продаж',
  menu_stock_alert: 'Предупреждение о запасах',
  menu_monthly_receivable_detail: 'Месячные детали дебиторской задолженности',
  menu_monthly_payable_detail: 'Месячные детали кредиторской задолженности',
  menu_cash_account: 'Наличный счет',
  menu_profit_statistics: 'Статистика прибыли',
  menu_supplier_manage: 'Управление поставщиками',
  menu_payment_type: 'Тип оплаты',
  menu_wx_mall: 'ВейЧат Молл',
  menu_sort: 'Категория',
  menu_order_status: 'Статус заказа',
  menu_wx_order: 'ВейЧат Заказы',

  menu_size: 'Размер',
  menu_order_management: 'Управление заказами',
  menu_finished_order: 'Выполненные заказы',
  menu_product_stuff_search: 'Поиск материалов продукта',
  menu_product_material_search: 'Поиск материалов продукта',
  menu_unsalable_report: 'Отчет о непродаваемых товарах',
  menu_bad_goods_transfer_out: 'Перемещение бракованных товаров',
  menu_terms_setting: 'Настройка условий',

  menu_task_type: 'Тип задачи',
  menu_task_finish_type: 'Тип завершения задачи',
  menu_task: 'Задача',
  menu_project_progress: 'Прогресс проекта',
  menu_issue_manage: 'Управление проблемами',
  menu_issue_category: 'Категория проблемы',
  menu_issue_collection: 'Сбор проблем',
  menu_material_stock: 'Запасы материалов',
  menu_product_stock: 'Запасы продукции',
  menu_sell_report: 'Отчет по продажам',


  // 餐飲管理系統
  menu_food_setting: 'Настройки продуктов',
  menu_food_category: 'Категория продуктов',
  menu_food_info: 'Информация о продуктах',
  menu_food_material_category: 'Категория ингредиентов',
  menu_food_material: 'Информация об ингредиентах',
  menu_option: 'Опции',
  menu_dining_table_setting: 'Настройки стола',
  menu_area2: 'Зона',
  menu_table_number: 'Номер стола',
  menu_recharge_offer: 'Предложения пополнения',
  menu_member_recharge: 'Пополнение для участников',
  menu_recharge: 'Управление пополнением',
  menu_discount_manage: 'Управление скидками',
  menu_discount_manage2: 'Управление предложениями',
  menu_discount: 'Запись скидки',
  menu_business_report_day: 'Ежедневный бизнес-отчет',
  menu_business_report_month: 'Ежемесячный бизнес-отчет',
  menu_sales_ranking: 'Рейтинг продаж',
  menu_food_material_report: 'Отчет об ингредиентах',
  menu_param: 'Настройки параметров',
  menu_production_location: 'Место производства',
  menu_service: 'Настройки обслуживания',

  menu_client_follow_up: 'Отслеживание клиентов',
  menu_follow_up_type: 'Тип отслеживания',
  menu_follow_up_entry: 'Запись отслеживания',
  menu_follow_up_report: 'Отчет об отслеживании',
  menu_sell_offer: 'Ценовое предложение продажи',
  menu_purchase_offer: 'Ценовое предложение закупки',

  menu_product_catetory: 'Категория продуктов',
  menu_material: 'Информация о материалах',
  menu_product: 'Информация о продуктах',
  menu_product_process: 'Процесс производства продукта',
  menu_personnel_manage: 'Управление персоналом',
  menu_department: 'Отдел',
  menu_job_title: 'Должность',
  menu_staff: 'Информация о сотрудниках',
  menu_grade: 'Уровень',

  menu_store_manage: 'Управление магазином',
  menu_goods_listing: 'Размещение товаров',
  menu_goods_drop: 'Снятие товаров с продажи',
  menu_retail_special: 'Специальные предложения для розничной торговли',
  menu_member_special: 'Специальные предложения для участников',
  menu_purchase_gift: 'Промоакция "Купи и получи"',
  menu_full_reduction_discount: 'Скидка за полную сумму',
  menu_special_package: 'Специальные пакеты',
  menu_retail_return: 'Возврат товаров',
  menu_daily_flow_report: 'Ежедневный отчет о движении средств',
  menu_setmeal: 'Комплексное меню',
  menu_length: 'Длина',
  menu_height: 'Высота',
  menu_cash_coupon: 'Наличный купон',
  menu_coupon: 'Купон',
  menu_specials: 'Специальные предложения',
  menu_member_specials: 'Специальные предложения для участников',
  menu_consignment_category: 'Категория консигнации',
  menu_post: 'Должность',
  menu_active_status: 'Статус занятости',

  menu_service_category: 'Категория услуг',
  menu_service_manage: 'Управление услугами',
  menu_trademark_category: 'Категория товарных знаков',
  menu_order_manage: 'Управление заказами',
  menu_about_us: 'О нас',
  menu_stock_state: 'Состояние запасов',
  menu_inspection_report: 'Отчет о проверке',
  menu_quality_control: 'Контроль качества',
  menu_quality_inspection: 'Проверка качества',
  menu_outgoing_inspection: 'Проверка на выходе',
  menu_invoicing_record: 'Запись счетов',
  menu_receipt_record: 'Запись о полученных счет-фактурах',
  menu_Consumption_report: 'Отчет о потреблении',

  menu_goods_disassembly_assembly_manage: 'Управление разборкой и сборкой товаров',
  menu_goods_disassembly: 'Разборка товаров',
  menu_goods_assembly: 'Сборка товаров',
}